module.exports = __webpack_public_path__ + "img/60ne.51d9d2ca.svg";